
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenUploadedFile {

    id: number;
    description: string;
    displayName: string;
    fileName: string;
    path: string;
    uploadDate: moment.Moment;
    userId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genUploadedFile: GenUploadedFile);
    constructor( id: number );

    constructor( input?: GenUploadedFile|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.description = input.description; // string [string]
            this.displayName = input.displayName; // string [string]
            this.fileName = input.fileName; // string [string]
            this.path = input.path; // string [string]
            if ( input.uploadDate && typeof input.uploadDate === 'string' ) {
                this.uploadDate = moment(input.uploadDate).utc();
            } else {
                this.uploadDate = input.uploadDate;
            }
            this.userId = input.userId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenUploadedFile[] {
        if (arr && arr.map) {
          return arr.map(a => new GenUploadedFile(a));
        } else {
          return [];
        }
    }
}

